var classes = {"productListHeroProduct":"AG-KD"};

export { classes as default };
